import {
    MANUFACTURERS_REFRESH_FIRMWARE_OPEN_MODAL,
    MANUFACTURERS_REFRESH_FIRMWARE_REQUEST,
    MANUFACTURERS_REFRESH_FIRMWARE_RESULT,
} from 'Redux/actionTypes';

export const manufacturersRefreshFirmwareOpenModal = () => ({
    type: MANUFACTURERS_REFRESH_FIRMWARE_OPEN_MODAL
})

export const manufacturersRefreshFirmwareRequest = () => ({
    type: MANUFACTURERS_REFRESH_FIRMWARE_REQUEST,
})

export const manufacturersRefreshFirmwareResult = (result) => ({
    type: MANUFACTURERS_REFRESH_FIRMWARE_RESULT,
    payload: result
})